const requests = require('@/js/requests')
import dbdexie from '@/js/db'

function group(nombres, codigos) {
  var mapper = {}
  for (let k = 0; k < nombres.length; k++) {
    // items.push( {name: nombres[k].toUpperCase(), cas:clases[k]})
    mapper[nombres[k].toUpperCase()] = codigos[k]
  }
  return mapper
}

export async function getdata() {
  let response = await requests.get(
    '/Listadoquimicos/produtos/temp/edemsa',
    3600 * 24, // se actualiza la consulta una vez al día
    false
  )
  return group(response.data.nombres, response.data.codigos)
}

export async function getchemicalproducts() {
  var externaldata = await getdata()
  var localdata = await get()
  return {...externaldata, ...localdata}
}

export async function get(fulldata=false) {
  // return all chemical products
  let response = await dbdexie.chem.toArray()
  var resp_as_dict
  if (!fulldata) {
    resp_as_dict = {}
    for (let k in response) {
      resp_as_dict[response[k].name] = response[k].codigo
    }
  } else {
    resp_as_dict = []
    for (let k in response) {
      resp_as_dict.push({id: response[k].id, name:response[k].name, codigo:response[k].codigo})
    }
  }
  return resp_as_dict
}
export async function post(data) {
  // add a chemical product
  // se verifica si el producto ya está registrado
  let ammount = await dbdexie.chem.where("name").equalsIgnoreCase(data.name).count()
  if (ammount === 0) {
    return await dbdexie.chem.add({
      name: data.name,
      date: currentdate(),
      codigo: data.codigo
    })
  }
  dbdexie.chem.where("name").equalsIgnoreCase(data.name).toArray().then(function (response) {
    put({id: response[0].id, ...data})
  })
}
export async function put(data) {
  // update an existent chemical product
  await dbdexie.chem.put({
    id: data.id,
    name: data.name,
    date: currentdate(),
    codigo: data.codigo
  })
}
export async function del(id) {
  // deletes an existent chemical product
  await dbdexie.chem.detele(id)
}

function currentdate() {
  let current = new Date()
  let cDate =
    current.getFullYear() +
    '-' +
    (current.getMonth() + 1) +
    '-' +
    current.getDate()
  let cTime =
    current.getHours() + ':' + current.getMinutes() + ':' + current.getSeconds()
  let dateTime = cDate + ' ' + cTime
  return dateTime
}
